import React from 'react';
import {Modal, Button} from 'react-bootstrap';
import {Trans} from 'react-i18next';
import frontendUtils from '../../utils/frontendUtils';

function ExternalLink({href, children}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{textDecoration: 'underline'}}
    >
      {children}
    </a>
  );
}

export default function PolicyConsentModal({show, onConfirm, showTos, showPp, functionType}) {
  const both = showTos && showPp;
  const tosUrl = functionType === 'SKINCARE_PRO'
    ? frontendUtils.getSkincareProTosUrl()
    : frontendUtils.getTosUrl();
  return (
    <Modal show={show} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>
          {both && (
            <Trans i18nKey="c.policy.consent.modal.title.both">
              Terms of Service &amp; Privacy Policy Update
            </Trans>
          )}
          {!both && showTos && (
            <Trans i18nKey="c.policy.consent.modal.title.tos">
              Terms of Service Update
            </Trans>
          )}
          {!both && showPp && (
            <Trans i18nKey="c.policy.consent.modal.title.pp">
              Privacy Policy Update
            </Trans>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {both && (
            <Trans i18nKey="c.policy.consent.modal.desc.both">
              We&apos;ve made a few updates to our Terms of Service &amp;
              Privacy Policy that went into effect recently.
            </Trans>
          )}
          {!both && showTos && (
            <Trans i18nKey="c.policy.consent.modal.desc.tos">
              We&apos;ve made a few updates to our Terms of Service that went
              into effect recently.
            </Trans>
          )}
          {!both && showPp && (
            <Trans i18nKey="c.policy.consent.modal.desc.pp">
              We&apos;ve made a few updates to our Privacy Policy that went into
              effect recently.
            </Trans>
          )}
        </p>
        <p>
          {both && (
            <Trans i18nKey="c.policy.consent.modal.learn.more.both">
              {'To learn more, please visit our '}
              <ExternalLink href={tosUrl}>
                Terms of Service
              </ExternalLink>
              {' & '}
              <ExternalLink href={frontendUtils.getPpUrl()}>
                Privacy Policy
              </ExternalLink>
              {'.'}
            </Trans>
          )}
          {!both && showTos && (
            <Trans i18nKey="c.policy.consent.modal.learn.more.tos">
              {'To learn more, please visit our '}
              <ExternalLink href={tosUrl}>
                Terms of Service
              </ExternalLink>
              {'.'}
            </Trans>
          )}
          {!both && showPp && (
            <Trans i18nKey="c.policy.consent.modal.learn.more.pp">
              {'To learn more, please visit our '}
              <ExternalLink href={frontendUtils.getPpUrl()}>
                Privacy Policy
              </ExternalLink>
              {'.'}
            </Trans>
          )}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onConfirm}>
          <Trans i18nKey="c.policy.consent.modal.button">
            I understand, continue
          </Trans>
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
